export default [
  {
    path: '/documentos-inscripciones',
    name: 'documentos-inscripciones',
    component: () => import('@/views/academico/documentos-inscripciones/DocumentosInscripcionesLayout.vue'),
  },
  {
    path: '/documentos-inscripciones/:id',
    name: 'documentos-inscripciones-ver',
    component: () => import('@/views/academico/documentos-inscripciones/DocumentosInscripcionesVer.vue'),
    props: true,
  },
  {
    path: '/documentos-por-programa',
    name: 'documentos-por-programa',
    component: () => import('@/views/academico/documentos-inscripciones/DocumentosPorProgramaLayout.vue'),
  },
];
